import * as Contentstack from 'contentstack';
const Stack = Contentstack.Stack(
    process.env.REACT_APP_API_KEY,
    process.env.REACT_APP_DELIVERY_TOKEN,
    process.env.REACT_APP_ENVIRONMENT
);

export const getTermsConditionContent = (store) => {
    let termscondition = {
        termscondition_status: 'INITIAL',
    };
    termscondition.termscondition_status = 'LOADING';
    store.setState({ termscondition });
    try {
        //termscondition page query
        const TermsConditionQuery = Stack.ContentType(
            'terms_conditions'
        ).Query();
        TermsConditionQuery.includeReference(['tc_details', 'tc_hero_image'])
            .toJSON()
            .find()
            .then(
                function success(result) {
                    const TermsConditionData = result[0];
                    const isContentEmpty = TermsConditionData.length == 0;
                    termscondition = isContentEmpty
                        ? termscondition
                        : TermsConditionData[0];
                    termscondition.termscondition_status = isContentEmpty
                        ? 'EMPTY'
                        : 'SUCCESS';
                    store.setState({
                        termscondition,
                    });
                },
                function error(err) {
                    const isError404 =
                        error.response && error.response.status === 404;
                    termscondition.termscondition_status = isError404
                        ? 'NOT_FOUND'
                        : 'ERROR';
                    store.setState({ termscondition });
                }
            );
    } catch (error) {
        store.setState({ status: 'ERROR`' });
    }
};
